import React from 'react';

/**
 * ChartTopbar - A customizable topbar component for charts
 * 
 * @param title - Optional title text displayed on the left side
 * @param leftContent - Optional custom content displayed on the left side (after title)
 * @param rightContent - Optional custom content displayed on the right side (typically filters/actions)
 * @param className - Optional additional CSS classes
 * 
 * Example usage:
 * <ChartTopbar 
 *   title="Sales Trend"
 *   rightContent={<Button>Filter</Button>}
 * />
 */
export interface ChartTopbarProps {
  title?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  className?: string;
}

const ChartTopbar: React.FC<ChartTopbarProps> = ({
  title,
  leftContent,
  rightContent,
  className = ''
}) => {
  return (
    <div className={`flex flex-wrap gap-y-3 items-start justify-between p-4 ${className}`}>
      {/* Left side - Title or custom content */}
      <div className="flex items-center">
        {title && (
          <h3 className="font-semibold text-primary_text" style={{ fontSize: '16px' }}>{title}</h3>
        )}
        {leftContent && (
          <div className="ml-4">
            {leftContent}
          </div>
        )}
      </div>

      {/* Right side - Filter or custom content */}
      <div className="flex flex-wrap items-center gap-2">
        {rightContent}
      </div>
    </div>
  );
};

export default ChartTopbar;
